import React from 'react';
import { Modal } from './ui/Modal';
import { Button } from './ui/Button';
import { TrashIcon } from './icons/TrashIcon';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  isLoading?: boolean;
}

export const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirmar Exclusão',
  message = 'Você tem certeza que deseja excluir este item? Esta ação não poderá ser desfeita.',
  isLoading = false,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="md">
      <div className="space-y-4">
        <p className="text-sm text-dark-text-primary">
          {message}
        </p>
        <div className="flex justify-end space-x-3 pt-4 border-t border-dark-tertiary mt-2">
          <Button type="button" variant="secondary" onClick={onClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button
            type="button"
            variant="danger"
            onClick={onConfirm}
            isLoading={isLoading}
            leftIcon={<TrashIcon />}
          >
            {isLoading ? 'Excluindo...' : 'Sim, Excluir'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
